import React from "react";
import "./admin.css";
import AdminForm from "./AdminForm";
import { Link, useNavigate } from "react-router-dom";
import Topbar from "../Global/topbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function Admin() {
  const navigate = useNavigate();
  return (
    <div className="admin-main">
      <div className="admin-container">
        <Topbar />
        <div className="admin-mid4">
          <div className="backbutton">
            <button
              onClick={() => {
                navigate("/admin/super_admin");
              }}
              className="logout"
            >
              {" "}
              <ArrowBackIcon style={{ fontSize: "2rem" }} />
            </button>{" "}
            <h1>New Admin</h1>
          </div>
          <div className="link">
            <Link href="" style={{ display: "none" }}>
              Dashboard
            </Link>{" "}
            <Link to="/admin/super_admin">Admin List</Link> &#62;{" "}
            <Link to="/admin/super_admin/create_super_admin"> New Admin</Link>
          </div>
        </div>
        <AdminForm />
      </div>
    </div>
  );
}
